import { useEffect } from "react";
import { useLazyGetConsumTransactionsFilteredQuery } from "../../../features/consumtransactions/consumTransApiSlice";

const FilteredConsumTransFetcher = ({ filters, onDataFetched }) => {
  const [triggerFetch, { data, isLoading, isError }] = useLazyGetConsumTransactionsFilteredQuery();

  useEffect(() => {
    // Trigger fetch with high limit to get all data for Excel download
    triggerFetch({
      page: 1,
      limit: 99999,
      filters,
    });
  }, [filters, triggerFetch]);

  useEffect(() => {
    if (data && !isLoading && !isError) {
      onDataFetched(data);
    }
  }, [data, isLoading, isError, onDataFetched]);

  return null; // This component doesn't render anything
};

export default FilteredConsumTransFetcher;

